// @flow

import React, { Component } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";
import Header from "../Header";
import "./LandingPage.scss";

export default class LandingPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: false,
      isHoveredTop: false,
      isHoveredBottom: false
    };
    this.handleHoverTop = this.handleHoverTop.bind(this);
    this.handleHoverBottom = this.handleHoverBottom.bind(this);
  }

  toggleMenu() {
    this.setState({
      menu: !this.state.menu
    });
  }
  handleHoverTop() {
    console.log("TOP");
    this.setState(prevState => ({
      isHoveredTop: !prevState.isHoveredTop
    }));
  }
  handleHoverBottom() {
    console.log("Bottom");
    this.setState(prevState => ({
      isHoveredBottom: !prevState.isHoveredBottom
    }));
  }
  closeMenu() {
    this.setState({
      menu: false
    });
  }
  componentDidMount() {
    window.addEventListener("scroll", this.resizeHeaderOnScroll);
  }

  resizeHeaderOnScroll() {
    let startOffsetTop = document.getElementById("main").offsetTop;
    const distanceY = window.pageYOffset || document.documentElement.scrollTop,
      shrinkOn = 200,
      headerEl = document.querySelector(".main-header");
    if (
      distanceY >= startOffsetTop + 200 ||
      distanceY <= startOffsetTop - 200
    ) {
      headerEl.classList.add("smaller");
    } else {
      headerEl.classList.remove("smaller");
    }
  }
  scrollWithOffset(el, offset, activeLink) {
    this.props.smoothScroll(el, offset, activeLink);
  }
  render() {
    return (
      <React.Fragment>
        <section id="main" className="landing-lp">
          <Header
            className="landing-header"
            type="landing-header"
            activeLink={this.props.activeLink}
          />
          <div className="landing-mid__wrapper">
            <div className="left-texts__container">
              <h3
                className={
                  this.state.isHoveredTop
                    ? "left-top-text hovered"
                    : "left-top-text"
                }
              >
                <NavLink
                  smooth
                  scroll={el => {
                    this.scrollWithOffset(el, 0, "roof");
                  }}
                  onClick={e => {
                    if (window.location.pathname == "/") {
                      e.preventDefault();
                    }
                  }}
                  className={
                    this.state.isHoveredTop
                      ? "basic-link hovered"
                      : "basic-link"
                  }
                  to={"/#roof"}
                >
                  Szybki dach
                </NavLink>
              </h3>
              <h3
                className={
                  this.state.isHoveredBottom
                    ? "left-bottom-text hovered"
                    : "left-bottom-text"
                }
              >
                <NavLink
                  smooth
                  scroll={el => {
                    this.scrollWithOffset(el, 0, "foundations");
                  }}
                  onClick={e => {
                    if (window.location.pathname == "/") {
                      e.preventDefault();
                    }
                  }}
                  className={
                    this.state.isHoveredBottom
                      ? "basic-link hovered "
                      : "basic-link dark-link"
                  }
                  to={"/#foundations"}
                >
                  Szybki fundament
                </NavLink>
              </h3>
            </div>
            <div className="landing-container container row">
              <div className="col-12 container center-col">
                <div className="col-6 landing-left__col">
                  <NavLink
                    smooth
                    scroll={el => {
                      this.scrollWithOffset(el, 0, "roof");
                    }}
                    onMouseEnter={this.handleHoverTop}
                    onMouseLeave={this.handleHoverTop}
                    onClick={e => {
                      if (window.location.pathname == "/") {
                        e.preventDefault();
                      }
                    }}
                    className="invis-top__link"
                    to={"/#roof"}
                  ></NavLink>
                  <img src="/img/dom.webp" className="house-picture" />
                  <NavLink
                    smooth
                    scroll={el => {
                      this.scrollWithOffset(el, 0, "foundations");
                    }}
                    onMouseEnter={this.handleHoverBottom}
                    onMouseLeave={this.handleHoverBottom}
                    onClick={e => {
                      if (window.location.pathname == "/") {
                        e.preventDefault();
                      }
                    }}
                    className="invis-bottom__link"
                    to={"/#foundations"}
                  ></NavLink>
                </div>
                <div className="col-5 col-ml-12 landing-right__col container">
                  <div className="col-12  row top-contaier">
                    <div className="top-text__container">
                      <h2 className="white-med__header red-bg">
                        Nawet w jeden dzień !
                      </h2>
                      <h1 className="white-big__header">2 x szybsza</h1>
                      <h2 className="red-med__header">Renowacja dachu</h2>
                    </div>
                  </div>
                  <div className="col-12  row bottom-container">
                    <div className="bottom-text__container">
                      <h2 className="white-med__header red-bg">
                        Nawet w jeden dzień !
                      </h2>
                      <h1 className="black-big__header">2 x szybsza</h1>
                      <h2 className="red-sm__header">
                        Hydroizolacja fundamentu
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <NavLink
              smooth
              scroll={el => {
                this.scrollWithOffset(el, 0, "foundations");
              }}
              onClick={e => {
                if (window.location.pathname == "/") {
                  e.preventDefault();
                }
              }}
              className="dark-link"
              to={"/#foundations"}
            >
              <div className="bottom-texts__container">
                <h3 className="left-bottom-text">Szybki fundament</h3>
              </div>
            </NavLink>
          </div>
          <div className="benefits-container container">
            <div className="benefit-container">
              <img src="/img/safety-light.svg" className="landing-icon" />
              <div className="icon-description">
                Bezpieczne dla termoizolacji
              </div>
            </div>
            <div className="benefit-container">
              <img src="/img/thumb-light.svg" className="landing-icon" />
              <div className="icon-description">Łatwe w aplikacji</div>
            </div>
            <div className="benefit-container">
              <img src="/img/fire-light.svg" className="landing-icon" />
              <div className="icon-description">
                Niepalne - bez rozpuszczalnikow
              </div>
            </div>
          </div>
          <NavLink
            smooth
            scroll={el => {
              this.scrollWithOffset(el, 0, "foundations");
            }}
            onClick={e => {
              if (window.location.pathname == "/") {
                e.preventDefault();
              }
            }}
            className="navigate-down__container dark-link"
            to={"/#foundations"}
          >
            <div className="navigate-down">
              <span className="af-icon-arrow" />
              <p className="icon-description">Fundamenty</p>
            </div>
          </NavLink>

          <NavLink
            smooth
            scroll={el => {
              this.scrollWithOffset(el, 0, "roof");
            }}
            onClick={e => {
              if (window.location.pathname == "/") {
                e.preventDefault();
              }
            }}
            className="navigate-up__container basic-link"
            to={"/#roof"}
          >
            <div className="navigate-up">
              <span className="af-icon-arrow" />
              <p className="icon-description">DACH</p>
            </div>
            {/* <div className="user-btn__container">
              <span className="af-icon-account"></span>
            </div> */}
          </NavLink>
        </section>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPage.js